import { lazy } from 'react';

import PublishUtils from './../../helpers/PublishUtils'

export default class TreeDescriptor {
  

    static getDescription() {
        return {
          name: 'Tree',
          component: lazy(() =>  import('./Tree')), 
          label: 'Tree widget',
          category:"basic",
          variables: [
            {
              name: 'query',
              type: 'yasgui',
              defaultQuery:"PREFIX owl: <http://www.w3.org/2002/07/owl#>\n\rPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\n\r\n\rselect distinct ?label ?uri ?parent ?icon ?description \n\rwhere\n\r{\n\r    \n\r    graph <{{graph}}>\n\r    {\n\r       ?uri a owl:Class.\n\r        ?uri rdfs:label ?label.\n\r    optional {?uri rdfs:subClassOf ?parent. } \n\r    optional {\n\r    filter not exists  {[] rdfs:subClassOf ?uri}   bind (\"leaf\" as ?icon2) }\n\r            bind (if(BOUND(?icon2),?icon2,\"star\") as ?icon)\n\r  \n\r    }\n\r}\n\r\n\rlimit 100",
              label:
                'Query to fill tree. First item should be the object label, the second the object URI, the third the parent URI. optional you can use icon, icon2 and icon3 variables for fa-fa icons and checkbox for checkbox version. Use ?description of an tooltip using a info icon',
            },
            {
              name: 'publishVariable',
              type: 'text',
              label:
                'Variabele in which tree item URI is published, when tree item is clicked.',
            },
            {
              name: 'publishVariable2',
              type: 'text',
              label:
                'Variabele in which tree item URI2 is published, when tree item is clicked.',
            },
            {
              name: 'publishVariable3',
              type: 'text',
              label:
                'Variabele in which tree item URI3 is published, when tree item is clicked.',
            },
            {
              name: 'publishVariable4',
              type: 'text',
              label:
                'Variabele in which tree item URI4 is published, when tree item is clicked.',
            },
            {
              name: 'subscribeVariable',
              type: 'text',
              label:
                'Publish variabele on which to listen to to define tree item selection.',
            },
            {
              name: 'textstyle',
              type: 'text',
              label: 'css class for text style. {w2ui}',
            },
            {
              name: 'rootLabel',
              type: 'text',
              label: 'Label of the root of the tree. Leave empty for no root.',
            },
            
            {
              name: 'expandLevel',
              type: 'int',
              label: 'initially expand the tree to this level',
            },
    
            {
              name: 'title',
              type: 'text',
              label: 'title',
            },
            {
              name: 'defaultIcon',
              type: 'text',
              label: 'fa icon name when no icon is defined. ',
            },
            {
              name: 'aggregate',
              type: 'boolean',
              label: 'Aggregate the results based upon parent and child uri ',
            },
            {
              name: 'shouldNonSelectedSubTreeClose',
              type: 'boolean',
              label:
                'Should a subtree that does not contain selection fold on new selection.',
            },
            {
              name: 'setSelectionInURL',
              type: 'boolean',
              label: 'the selected URI will be used in the browser URL. THIS WORKS ONLY WHEN browser URL is similar to the selection (Security reasons)',
            },
            {
              name: 'debugSetSelectionInURL',
              type: 'boolean',
              label: 'sets a ?selection parameter in the browser url for Debug reasons',
            },
            {
              name: 'setSelectionInURLStartsString',
              type: 'text',
              label:
                'the selected URI will be used in the browser URL only if it starts with this text. . ',
            },
            {
              name: 'parseInitialURLForSelection',
              type: 'boolean',
              label: 'parse the initial URL for selection',
            },
            {
              name: 'initialSelection',
              type: 'text',
              label: 'initial uri selection',
            },
            {
              name: 'scrollSelectionIntoView',
              type: 'boolean',
              label: 'try to automatically scroll the selected object into view',
            },
            {
              name:'multipleCheckBoxParameter',
              type:'text',
              label:"parameter for (multiple) checkbox values "
            }
              ,
            PublishUtils.getMultipleValueFormatOptions(),
            {
              name: 'deletebuttonrule',
              type: 'text',
              label: 'uri or tag for rule when pushing delete icon',
            },
            {
              name: 'deletebuttonruleParams',
              type: 'json',
              label: 'Extra parameters send to the rule when pushing delete icon. Should be a flat JSON with string-only values.',
            },
            {
              name: 'allowNonLeafDeletion',
              type: 'boolean',
              label: 'Allow deletion of items with children',
            },
            PublishUtils.getTimestampParametersDef()
          ]
        }
      }
    
}